<script lang="ts">
  import type { Meta } from "types/backend/models/cms/meta.entity";
  import { hasHttp } from "./meta-utils";
  import { utils } from "$lib/utils";

  export let meta: Meta;
  const PUBLIC_URL = utils.getHost();

  // $: ({ type, title, description, image, url, site_name, og, twitter } = meta);
  let { type, title, description, image, url, site_name, og, twitter } = meta;
  function fillTitle(title = "") {
    const unique = new Set();
    const parts = title
      .trim()
      .split("|")
      .map(v => v.trim());
    parts.push("Football Ticket Pad");

    return parts
      .filter(v => {
        if (v && !unique.has(v)) {
          unique.add(v);
          return true;
        }
        return false;
      })
      .join(" | ");
  }
</script>

<svelte:head>
  {#if title}
    <title>{fillTitle(title)}</title>
  {/if}
  {#if description}
    <meta name="description" content={description} />
  {/if}

  {#if og}
    {#if type}
      <meta property="og:type" content={type} />
    {/if}
    {#if title}
      <meta property="og:title" content={title} />
    {/if}
    {#if description}
      <meta property="og:description" content={description} />
    {/if}
    {#if image}
      <meta property="og:image" content={image} />
    {/if}
    {#if url}
      <meta property="og:url" content={hasHttp(url) ? utils.slugify(url) : `${PUBLIC_URL}${utils.slugify(url)}`} />
    {/if}
    {#if site_name}
      <meta property="og:site_name" content={site_name} />
    {/if}
  {/if}

  {#if twitter}
    {#if title}
      <meta name="twitter:title" content={title} />
    {/if}
    {#if description}
      <meta name="twitter:description" content={description} />
    {/if}
    {#if image}
      <meta name="twitter:image" content={image} />
    {/if}
    <meta name="twitter:site" content="@ticketpad" />
    <meta name="twitter:creator" content="@ticketpad" />
  {/if}
</svelte:head>
